import adminState from './initialState';

export default adminState;
